<template>
    <div class="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6 pb-0">
        <div class="my-2 -ml-2 flex h-16 shrink-0 items-center cursor-pointer" @click="openLink">
            <img class="mt-4 h-11 w-auto mx-auto" src="../assets/logo.png" alt="Your Company" />
        </div>
        <nav class="flex flex-1 flex-col">
            <ul role="list" class="flex flex-1 flex-col gap-y-4">
                <li v-for="items in navigation" :key="items.name">
                    <div class="text-sm leading-6 text-[#ADACB0]">{{ items.name }}</div>
                    <ul role="list" class="-mx-2 space-y-1">
                        <li v-for="item in items.children" :key="item.name" @click="navigateTo(item.href)">
                            <div :href="item.href"
                                :class="[route.name == item.href ? 'bg-[#F5F8FD] text-[#1751D0]' : 'text-[#4F4D55] hover:text-[#1751D0] hover:bg-[#F5F8FD]', 'cursor-pointer group flex gap-x-3 items-center rounded-md p-2 text-sm leading-4']">
                                <component :is="item.icon"
                                    :class="[route.name == item.href ? 'text-[#1751D0]' : 'text-[#4F4D55] group-hover:text-[#1751D0]', 'h-5 w-5 shrink-0']"
                                    aria-hidden="true" />
                                {{ item.name }}
                            </div>
                        </li>
                    </ul>
                </li>
                <li class="-mx-6 mt-auto">
                    <a href="#" @click.prevent="router.push('/setting')"
                        class="flex items-center gap-x-4 px-6 py-3 text-sm font-semibold leading-6 text-[#262628] hover:bg-[#F5F8FD]">
                        <img class="h-8 w-8 rounded-full bg-white" :src="url" alt="" />
                        <span class="sr-only">Your profile</span>
                        <span aria-hidden="true">{{
                            store.state.userInfo.user_name || ('爱校对' + (store.state.userInfo.phone
                                ?
                                store.state.userInfo.phone.slice(7) : '')) }}</span>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script setup>
import {
    useRoute,
    useRouter
} from 'vue-router'
import { computed } from 'vue'
import store from '@/store'
import {
    GlobeAsiaAustraliaIcon,
    FolderIcon,
    InboxIcon,
    // UsersIcon,
    SparklesIcon,
    BeakerIcon,
    LinkIcon,
    ComputerDesktopIcon,
    CubeIcon,
    ChartPieIcon,
    BellAlertIcon,
    MagnifyingGlassIcon,
    UserCircleIcon,
    ChartBarIcon
} from '@heroicons/vue/24/outline'
const route = useRoute()
const router = useRouter()
const navigation = [
    {
        name: '公共',
        icon: GlobeAsiaAustraliaIcon,
        current: false,
        children: [
            { name: '数据看板', href: 'Dashboard', icon: ChartPieIcon, current: true },
            { name: '任务管理', href: 'TaskList', icon: InboxIcon, current: false },
            { name: '提醒管理', href: 'AlertManage', icon: BellAlertIcon, current: false },
            { name: '词库管理', href: 'Dictionary', icon: FolderIcon, current: false },
            { name: '关键词检索', href: 'KeySearch', icon: MagnifyingGlassIcon, current: false },
            { name: '用户管理', href: 'UserManage', icon: UserCircleIcon, current: false },
        ],
    },
    {
        name: '网站监测',
        icon: GlobeAsiaAustraliaIcon,
        current: false,
        children: [
            { name: '首页更新', href: 'HomeUpdate', icon: ComputerDesktopIcon, current: false },
            { name: '错敏信息', href: 'WebsiteSensitive', icon: SparklesIcon, current: false },
            { name: '数据统计', href: 'ErrorStatistics', icon: ChartBarIcon, current: false },
            { name: '栏目更新', href: 'ColumnUpdate', icon: CubeIcon, current: false },
            { name: '链接可用性', href: 'LinkAvailability', icon: LinkIcon, current: false },
        ],
    },
    {
        name: '新媒体监测',
        icon: BeakerIcon,
        current: false,
        children: [
            { name: '错敏信息', href: 'WeChatSensitive', icon: SparklesIcon, current: false },
            { name: '数据统计', href: 'WeChatErrorStatistics', icon: ChartBarIcon, current: false },
        ],
    },
];
const url = computed(() => {
    return store.state.imgUrl
})

function openLink() {
    window.open('https://www.ijiaodui.com', '_blank');
}

// 动态导航函数
function navigateTo(item) {
    router.push({ name: item });
}
</script>

<style></style>
